'use client';

import { useLocale, useTranslations } from 'next-intl';
import { SectionWrapper } from '@/components/ui/section-wrapper';
import { Button } from '@/components/ui/button';
import { getLocalizedPath } from '@/lib/locale-utils';
import { FaqContent } from '@/components/frontend/faq/faq-page-content';

type FaqItem = { id: string; question: string; answer: string };

export function FAQSection({ initialFaqs }: { initialFaqs?: FaqItem[] } = {}) {
    const t = useTranslations('home.faq');
    const locale = useLocale();

    return (
        <SectionWrapper
            variant="default"
            padding="md"
            className="relative overflow-hidden !bg-transparent  after:content-[''] after:absolute after:inset-0 after:bg-[url('/images/home/MLM-Business.webp')] after:bg-cover after:bg-center after:-z-10 after:opacity-100 dark:after:opacity-0"
        >
            <div className="pointer-events-none absolute inset-0 opacity-40">
                <div className="absolute left-1/4 top-0 h-96 w-96 rounded-full bg-primary-500/10 blur-3xl" />
                <div className="absolute right-1/4 bottom-0 h-96 w-96 rounded-full bg-blue-500/10 blur-3xl" />
            </div>

            <div className="relative z-10 max-w-5xl mx-auto text-center">
                <FaqContent showHeading limitItems={true} initialItems={initialFaqs} />
            </div>

            <div className="relative z-10 mt-10 text-center">
                <Button
                    href={getLocalizedPath('faq', locale)}
                    variant="primary"
                    size="md"
                    className="w-full  sm:w-auto  justify-center inline-flex"
                    ariaLabel={t('ctaLabel')}
                >
                    {t('ctaLabel')}
                </Button>
            </div>
        </SectionWrapper>
    );
}

